// import * as Sentry from '@sentry/vue';
import { emailSchema, newEmailTokenSchema } from "~/utils/schemas";

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return;

  const email = to.query.email;
  const oldEmail = to.query.old_email;
  const token = to.query.token;

  try {
    emailSchema.parse(email);
    emailSchema.parse(oldEmail);
    newEmailTokenSchema.parse(token);
  } catch {
    showError({
      statusMessage:
        "Nieprawidłowy link do potwierdzenia zmiany maila. Sprawdź swoją skrzynkę mailową i spróbuj ponownie.",
    });
    // Sentry.captureException(new Error('Invalid password reset link'));
  }
});
